import Modal from "components/Models/index";
import React from "react";

import "./deleteModal.scss";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";

// import deleteIcon from "assets/images/fileImage/deleteIcon.svg";
// import deleteIconDark from "assets/images/fileImage/deleteDark.svg";
import useTheme from "hooks/observer";
import useScreenMobile from "hooks/useScreen";

const DeleteModal = ({
  handleCancel,
  handleSave,
  content = "",
  title = "",
  showHeader = null,
  headerTitle = "Delete",
  type = "delete",
  submitBtnText = "Delete"
}) => {
  // We still use isMobile for the cross icon logic if needed, but we'll try to do more in CSS
  const isMobile = useScreenMobile({ size: 768 });

  // Force header to be hidden to allow red trash icon to be the top element
  const shouldShowHeader = false;

  const theme = useTheme();

  const getModalStyles = () => {
    switch (type) {
      case "block":
        return {
          submitBtnColor: "delete", // Reuse delete color for block warning
          iconColor: isMobile ? "white" : (theme === "dark" ? "#BE2828" : "#DC1818")
        };
      case "unblock":
        return {
          submitBtnColor: "violet", // Using standard primary color action
          iconColor: isMobile ? "white" : (theme === "dark" ? "#7D708A" : "#BDB8C2") // Using standard icon color rather than red warning
        };
      default:
        return {
          submitBtnColor: "delete",
          iconColor: isMobile ? "white" : (theme === "dark" ? "#BE2828" : "#DC1818")
        };
    }
  };

  const styles = getModalStyles();

  return (
    <Modal
      submitBtnColor={styles.submitBtnColor}
      submitBtnText={submitBtnText}
      handleCancel={handleCancel}
      handleSave={handleSave}
      showHeader={shouldShowHeader}
      showCross={shouldShowHeader}
      heading={headerTitle}
      customClass="deleteModalFooter"
      containerClass="deleteModalWrapper"
    >
      <div className="deleteContainer">
        <div className="redTrashHeader">
          <GetActionIcon
            type={type}
            color={styles.iconColor}
          />
        </div>
        <div className="deleteContent">
          <p className="mainContent">{content}</p>
          {title && <p className="subtitle">{title}</p>}
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;

// <p
//           style={{
//             maxWidth: "100%",
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             whiteSpace: "nowrap",
//             wordBreak: "break-all",
//           }}
//           title={content}
//         >
//           {content.length > 30
//             ? `${content.slice(0, 20)}.....${content.slice(-7)}`
//             : content}
//         </p>
//         {title && (
//           <p
//             className="subtitle"
//             style={{
//               maxWidth: "100%",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//               wordBreak: "break-all",
//             }}
//             title={title}
//           >
//             {title.length > 30
//               ? `${title.slice(0, 20)}.....${title.slice(-7)}`
//               : title}
//           </p>
//         )}